import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LinkValidationGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const queryParams = route.queryParams;

    // Extract link parameters from query string
    const user1Id = queryParams['user1Id'] || '';
    const user2Id = queryParams['user2Id'] || '';
    const validationKey = queryParams['key'] || '';

    // Check if all required parameters are present
    if (!user1Id || !user2Id || !validationKey) {
      this.router.navigate(['/error'], {
        state: { message: 'Invalid or missing link parameters.' }
      });
      return of(false);
    }

    // Authenticate with the API to get JWT token
    return this.authService.authenticate(user1Id, user2Id, validationKey).pipe(
      map(response => {
        if (response.success && response.token) {
          // Token is already stored by the auth service
          return true;
        } else {
          this.router.navigate(['/error'], {
            state: { message: response.message || 'Authentication failed.' }
          });
          return false;
        }
      }),
      catchError(error => {
        console.error('Authentication error:', error);
        this.router.navigate(['/error'], {
          state: { message: 'An error occurred while authenticating.' }
        });
        return of(false);
      })
    );
  }
}
